<div class=" o-modal--alert o-modal--error o-modal--medium" id="mod-mod-req2" style="width: 100%;">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{ 'ModalRejectPortal.title' | translate }}</label>
    </div>


    <div class="o-modal__body" style="padding-left: 40px;">
        <p>{{ 'ModalRejectPortal.body' | translate }}</p>
    </div>
    <div class="o-modal__footer">
        <div> 
            <button mat-button mat-dialog-close class="btn btn--default" style="padding-left: 19px;">{{ 'ModalRejectPortal.btnCancel' | translate }} </button>
            <button mat-button class="btn btn--primary" (click)="closeModalReject()">{{ 'ModalRejectPortal.btnReject' | translate }}</button>
        </div>
    </div>

</div>
<!-- modificacion -->
